/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

/**
 * Giorno della settiman, giorni previsti :   -*LUN*: lunedi  -*MAR*: martedi  -*MER*: mercoledi  -*GIO*: giovedi  -*VEN*: venerdi  -*SAB*: sabato  -*DOM*: domenica
 */
export type GiornoDellaSettimanaEnum = 'LUN' | 'MAR' | 'MER' | 'GIO' | 'VEN' | 'SAB' | 'DOM';

export const GiornoDellaSettimanaEnum = {
    LUN: 'LUN' as GiornoDellaSettimanaEnum,
    MAR: 'MAR' as GiornoDellaSettimanaEnum,
    MER: 'MER' as GiornoDellaSettimanaEnum,
    GIO: 'GIO' as GiornoDellaSettimanaEnum,
    VEN: 'VEN' as GiornoDellaSettimanaEnum,
    SAB: 'SAB' as GiornoDellaSettimanaEnum,
    DOM: 'DOM' as GiornoDellaSettimanaEnum
};